import React from 'react';

interface ApiErrorProps {
  error: any;
  fallbackMessage?: string;
}

const ApiError: React.FC<ApiErrorProps> = ({ error, fallbackMessage = 'Произошла ошибка' }) => {
  const getErrorMessage = () => {
    if (error?.data?.message) {
      return error.data.message;
    }
    if (error?.error) {
      return error.error;
    }
    if (typeof error === 'string') {
      return error;
    }
    return fallbackMessage;
  };

  return (
    <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded">
      {getErrorMessage()}
    </div>
  );
};

export default ApiError; 